// extracted by mini-css-extract-plugin
export default {"root":"VBtxD","radioButton":"L6y4F","footer":"ARSVT","button":"_2l52n"};